import { useState } from "react";
import { format, parseISO } from "date-fns";
import { CalendarBlank, X } from "@phosphor-icons/react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

// value / onChange use ISO date strings "yyyy-MM-dd" ("" = empty)
export function DatePicker({ value, onChange, placeholder = "Pick a date", testid, className }) {
  const [open, setOpen] = useState(false);
  const selected = value ? parseISO(value) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          data-testid={testid}
          variant="outline"
          onClick={(e) => e.stopPropagation()}
          className={cn("mt-1 w-full justify-start rounded-sm font-mono text-xs h-10", !value && "text-muted-foreground", className)}
        >
          <CalendarBlank size={14} className="mr-2 shrink-0" />
          {value ? format(selected, "dd MMM yyyy") : placeholder}
          {value && (
            <span
              role="button"
              data-testid={testid ? `${testid}-clear` : undefined}
              onClick={(e) => { e.stopPropagation(); onChange(""); }}
              className="ml-auto text-muted-foreground hover:text-foreground"
            ><X size={13} /></span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={selected}
          onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
